import request from '@/shared/api/request';

export const deleteBucket = (name: string): Promise<unknown> =>
  request({
    url: `/buckets/${name}/`,
    method: 'DELETE',
  });
